import activityService from 'services/ActivityService';
import CoursewareTargetProvider from './CoursewareTargetService';

const targetProvider = CoursewareTargetProvider.build();

class ThemeServices {
  constructor({ context, id, coursewareType, target = {} }) {
    this.context = context;
    this.id = target.id || id;
    this._targetId = null;
    this.coursewareType = target.type || coursewareType;
  }

  async _getTargetId() {
    const target = await targetProvider.createTarget(this.id);
    const rootTarget = target.ancestry.slice(-1)[0];
    this._targetId = rootTarget ? rootTarget.elementId : this.id;
    return this._targetId;
  }

  async getInTheme(path = []) {
    const targetId = this._targetId || await this._getTargetId();
    const selectedTheme = await  activityService.getInSelectedTheme(targetId);
    const theme = await activityService.getInActivityTheme(targetId, path);
    return selectedTheme || theme || {};
  }

  async subscribeToTheme(path, callback) {
    const listener = (themeConfig) => {
      const processConfig = async () => Promise.resolve(themeConfig);
      processConfig().then((config) => callback(config));
    };
    const targetId = this._targetId || await this._getTargetId();
    return activityService.subscribeToThemePart(targetId, path, listener);
  }

  static build(args) {
    return new ThemeServices(args);
  }
}

export default ThemeServices;
